import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";


import styles from "assets/jss/material-kit-react/views/landingPage.js";
import brandImage from "assets/img/iese-logo-navbar.png";
import ErrorInside from "views/ErrorPage/ErrorPageInside"


const useStyles = makeStyles(styles);

export default function ErrorPage(props) {
    const classes = useStyles();
    const {...rest} = props;
   
    return (
        <div className={classes.errorpagebackground}>
            <Header
                color="transparent"
                brand={<img style={{ filter: "brightness(0) invert(1)" }}
                    src={brandImage}
                    className={classes.img}
                    alt="brand"
                />}
                fixed
                {...rest}
            />
            <ErrorInside/>
        </div>

    );
}